import React from 'react';

import redIcon from '../../assets/images/marker-icon-red.png';
import yellowIcon from '../../assets/images/marker-icon-yellow.png';
import greenIcon from '../../assets/images/marker-icon-green.png';
import { useTranslation } from 'react-i18next';

const MapLegend = () => {
  const { t } = useTranslation();

  return (
    <div className="legend">
      <h4>Legend</h4>

      <div className="legend-item">
      <img className="legend-icon" src={greenIcon}/>
        <span>{t('No Incidents')}</span>
      </div>
      <div className="legend-item">
        <img className="legend-icon" src={yellowIcon}/>
        <span>{t('Open Incidents')}</span>
      </div>
      <div className="legend-item">
        <img className="legend-icon" src={redIcon}/>
        <span>{t('Critical Incidents')}</span>
      </div>

      <div className="legend-item">
        <span className="legend-icon" style={{ backgroundColor: 'gray' }}></span>
        <span>{t('Number of Restaurants')}</span>
      </div>
    </div>
  );
};

export default MapLegend;
